/** A fixed day no time zone changes its offset on, so every `HH:mm` exists on it (R4-08). */
const TIME_OF_DAY_CARRIER_DAY = { year: 2000, monthIndex: 0, day: 3 } as const;

/**
 * The calling window times are wall-clock `HH:mm` texts: the picker's `Date` only carries hours and
 * minutes in its local fields, so no time zone conversion happens in either direction.
 */
export function toTimeOfDayText(value: Date): string {
  return `${String(value.getHours()).padStart(2, '0')}:${String(value.getMinutes()).padStart(2, '0')}`;
}

export function fromTimeOfDayText(text: string | null | undefined): Date | null {
  const match = /^(\d{2}):(\d{2})$/.exec(text ?? '');
  if (!match) {
    return null;
  }

  return new Date(
    TIME_OF_DAY_CARRIER_DAY.year,
    TIME_OF_DAY_CARRIER_DAY.monthIndex,
    TIME_OF_DAY_CARRIER_DAY.day,
    Number(match[1]),
    Number(match[2]),
  );
}
